import ShippingList    from '../../../pages/store/shipping/List';
import ShippingFeeList from '../../../pages/store/shipping/fee/List';
import ShippingFeeEdit from '../../../pages/store/shipping/fee/Edit';
import WarehouseList   from '../../../pages/store/warehouse/List';
import WarehouseEdit   from '../../../pages/store/warehouse/Edit';
import ShopList        from '../../../pages/store/shop/List';
import CouponList      from '../../../pages/store/coupon/List';
import ProductEdit     from '../../../pages/store/shop/Edit';
import ProductCreate   from '../../../pages/store/shop/Create';
import CreateStore     from '../../../pages/store/Create';
import {
	getStoreBankRoute,
	getStoreCouponsRoute,
	getStoreProductCreateRoute,
	getStoreProductCreateVariationRoute,
	getStoreProductEditRoute,
	getStoreShipmentsRoute,
	getStoreShippingFeeEditRoute,
	getStoreShippingFeesRoute,
	getStoreShopRoute,
	getStoreWarehouseEditRoute,
	getStoreWarehouseRoute,
	getStoreWizardRoute
}                      from './factory/store';
import Bank            from '../../../pages/store/Bank';

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
	{
		path: getStoreCouponsRoute(),
		component: CouponList,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getStoreShipmentsRoute(),
		component: ShippingList,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getStoreShopRoute(),
		component: ShopList,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getStoreProductCreateRoute(),
		component: ProductCreate,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getStoreProductCreateVariationRoute(),
		component: ProductCreate,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getStoreProductEditRoute(),
		component: ProductEdit,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getStoreWarehouseRoute(),
		component: WarehouseList,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getStoreWarehouseEditRoute(),
		component: WarehouseEdit,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getStoreWizardRoute(),
		component: CreateStore,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getStoreBankRoute(),
		component: Bank,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getStoreShippingFeesRoute(),
		component: ShippingFeeList,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getStoreShippingFeeEditRoute(),
		component: ShippingFeeEdit,
		type: 'route',
		loginRequired: true,
	},
];

export default routes;
